import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'help_center-view_order_details_from_action_modal-click';

/**
 * View order details link from action modal
 */
export function trackHelpCenterViewOrderDetailsFromActionModalClick(
  action_type: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { action_type },
  });
}
